package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

import androidx.compose.runtime.Composable

sealed interface ToolbarHeaderComponentConfig {

    data class Text(
        val text: String,
        val alpha: Float = 1f,
    ) : ToolbarHeaderComponentConfig

    data class CustomContent(
        val content: @Composable () -> Unit,
    ) : ToolbarHeaderComponentConfig
}
